import src from "IMAGE";
export default { src, width: 513, height: 207, blurWidth: 0, blurHeight: 0};
